<template>
  <USModal
    data-test="add-new-modal"
    :is-open="isOpen"
    class="add-new-modal"
    @update:isOpen="$emit('update:isOpen', $event)"
  >
    <div v-if="heading || $slots.heading" class="heading--h3 margin-bottom--6">
      <slot name="heading">
        <h3>{{ heading }}</h3>
      </slot>
    </div>
    <div
      v-if="description || $slots.description"
      class="body--p1--regular margin-bottom--6"
    >
      <slot name="description">
        <p>{{ description }}</p>
      </slot>
    </div>
    <USInputText
      v-model="entityName"
      :error="entityNameError"
      :placeholder="placeholder"
      :input-id="inputId"
      :name="name"
      minlength="1"
      maxlength="255"
      class="add-new-modal__input"
    />
    <div v-if="askForNonGolfClub" class="margin-top--6 text-align--left ">
      <USInputCheckbox
        v-model="isNonGolf"
        name="isNonGolf"
        input-id="isNonGolf"
        heading="Off-Course Club"
        label="This Club is an Off-Course Club (simulators, ranges, restaurants, etc)"
      />
    </div>
    <div v-if="askForNonGolfEvent && !isNonGolfClub" class="margin-top--6 text-align--left ">
      <USInputCheckbox
        v-model="isNonGolf"
        name="isNonGolf"
        input-id="isNonGolf"
        heading="Off-Course Event"
        label="This Event is an Off-Course Event (brunch, simulator event, wine tasting, etc)"
      />
    </div>
    <USButton
      is="button"
      :label="buttonLabel"
      class="add-new-modal__btn margin-top--5"
      @click="handleSubmit"
    />
  </USModal>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import USModal from '@base/components/USModal/USModal.vue'
import USInputText from '@base/components/USInputText/USInputText.vue'
import USButton from '@base/components/USButton/USButton.vue'
import USInputCheckbox from '@base/components/USInputCheckbox/USInputCheckbox.vue'

export default defineComponent({
  name: 'AddNewModal',
  components: { USModal, USInputText, USButton, USInputCheckbox},
  props: {
    isOpen: { type: Boolean, default: false },
    inputId: { type: String, default: '' },
    name: { type: String, default: '' },
    heading: { type: String, default: '' },
    description: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    buttonLabel: { type: String, default: '' },
    askForNonGolfClub: { type: Boolean, default: false },
    askForNonGolfEvent: { type: Boolean, default: false },
    isNonGolfClub: { type: Boolean, default: false },
  },
  emits: ['add', 'update:isOpen'],
  setup(props, { emit }) {
    const entityName = ref('')
    const entityNameError = ref('')
    const isNonGolf = ref(props.isNonGolfClub)

    const handleSubmit = () => {
      entityNameError.value = ''

      if (!entityName.value) {
        entityNameError.value = 'This field is required'
        return
      }

      if (props.askForNonGolfClub || props.askForNonGolfEvent) {
        emit('add', entityName.value, isNonGolf.value)
      } else {
        emit('add', entityName.value)
      }
    }

    return { 
      entityName,
      entityNameError,
      isNonGolf,
      handleSubmit
    }
  }
})
</script>

<style lang="scss" scoped>
.add-new-modal {
  text-align: center;
}
</style>
